import { LISTING_STATUS } from '@constants/property'
import Image from '@global/Image'
import { formatDate } from '@lib/date'
import PropertyAddress from '../PropertyAddress'
import * as S from './EnquiryHeader.styled'

const ListingEnquiry = ({ listing }) => {
  const isDisplayAuction =
    listing.auction_date &&
    listing.status !== LISTING_STATUS.SOLD &&
    !listing.underOffer
  const { images } = listing

  return (
    <S.ListingEnquiry>
      <S.ListingEnquiryImage>
        {listing.status !== LISTING_STATUS.SOLD &&
        listing.status !== LISTING_STATUS.LEASED ? (
          <Image
            alt={listing.title}
            src={images?.[0]?.image?.image_1920_1080}
          />
        ) : (
          listing.status
        )}
      </S.ListingEnquiryImage>
      <S.ListingEnquiryContent>
        <PropertyAddress listing={listing} />
        {isDisplayAuction && (
          <S.Auction>
            <span>Auction</span>{' '}
            {formatDate(new Date(listing.auction_date), 'MMMM do')}
          </S.Auction>
        )}
      </S.ListingEnquiryContent>
    </S.ListingEnquiry>
  )
}

export default ListingEnquiry
